import Ractive from "ractive";
import $ from "jquery";
import _ from "lodash";
import moment from "moment";

import Formatter from "utils/formatter";

require('datepicker/datepicker');

//////////////////////////////////////////////////////////////////////////////////////

const formatter = new Formatter();

//////////////////////////////////////////////////////////////////////////////////////

/**
 * DateRangePicker is used for date selection used for reporting
 */
module.exports = Ractive.extend({
    template: '#date-range-picker',

    onrender: function() {

        console.debug('#DateRangePicker@oninit – Initialize Date picker');

        let that         = this;
        let start        = moment().subtract(29, 'days');
        let end          = moment();
        let $datePicker  = $('.date-range-field');

        $datePicker.daterangepicker(
            {
                autoUpdateInput: true,
                startDate: start,
                endDate: end,
                ranges: {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'This Month': [moment().startOf('month'), moment().endOf('month')],
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                }
            },
            (start, end) => {
                that.setDate(start, end);
            }
        );

        this.datepicker = $datePicker.data('daterangepicker');
        this.$el        = $datePicker;

        this.setDate(start, end);
    },

    /**
     * Update the date selection display
     * of the date picker
     */
    updateDateSelectionDisplay: function() {
        let app = this.root;

        $('span', this.$el).html(
            app.get('dateRange.formatted.from') + ' - ' + app.get('dateRange.formatted.to')
        );
    },

    /**
     * Sets the date range
     * 
     * @param {moment} from - Start date range
     * @param {moment} to   - End date range
     */
    setDate: function(from, to) {

        console.debug('#DatePicker@setDate - Setting date to: ', from, to);

        let app        = this.root;
        let datePicker = this.datepicker;

        from = (_.isString(from)) ? moment(from) : from;
        to   = (_.isString(to)) ? moment(to) : to;

        datePicker.setStartDate(from);
        datePicker.setEndDate(to);

        // ----------------------------------------------------------------

        app.set('dateRange.from', formatter.date.toFormal(from));
        app.set('dateRange.to', formatter.date.toFormal(to));

        app.set('dateRange.formatted.from', formatter.date.humanized(from));
        app.set('dateRange.formatted.to', formatter.date.humanized(to));

        // ----------------------------------------------------------------
        
        this.updateDateSelectionDisplay();
    }
});